import { render, staticRenderFns } from "./IconVk.vue?vue&type=template&id=780771ce&"
import script from "./IconVk.vue?vue&type=script&lang=js&"
export * from "./IconVk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports